import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c2105a4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "m-4 px-4 sm:px-6 lg:px-8" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex sm:items-center" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "sm:flex-auto" }, [
        /*#__PURE__*/ _createElementVNode("h1", { class: "text-xl font-semibold text-gray-900" }, "Resourcing Dashboard")
    ])
], -1));
const _hoisted_3 = { class: "mt-8 flex flex-col md:flex-row justify-end" };
const _hoisted_4 = { class: "mt-2 grow" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { for: "search" }, "Search:", -1));
const _hoisted_6 = { class: "mt-2 md:ml-2" };
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", {
    for: "filter-doctype",
    class: "text-gray-600"
}, "Stage:", -1));
const _hoisted_8 = {
    key: "all",
    value: "all"
};
const _hoisted_9 = ["value"];
const _hoisted_10 = { class: "mt-8 flex flex-col" };
const _hoisted_11 = { class: "my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8" };
const _hoisted_12 = { class: "inline-block min-w-full py-2 align-middle md:px-6 lg:px-8" };
const _hoisted_13 = { class: "overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg" };
const _hoisted_14 = { class: "min-w-full divide-y divide-gray-300" };
const _hoisted_15 = { class: "bg-gray-50" };
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
    key: 0,
    class: "absolute"
};
const _hoisted_18 = {
    key: 0,
    class: "bg-white"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_21 = { key: 0 };
const _hoisted_22 = { key: 1 };
const _hoisted_23 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_24 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_25 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_26 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_27 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_28 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_29 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_30 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_31 = { class: "whitespace-nowrap px-3 py-4 sm:pl-6 text-sm text-gray-500" };
const _hoisted_32 = {
    key: 0,
    class: "text-gray-400 text-center p-8"
};
const _hoisted_33 = { class: "flex justify-center md:justify-end mx-1 md:mx-8 my-4 px-4 md:px-8 py-4 shadow rounded ring-1 ring-black ring-opacity-5" };
const _hoisted_34 = ["disabled"];
const _hoisted_35 = ["disabled"];
import { ArrowSmDownIcon, ArrowSmUpIcon } from '@heroicons/vue/solid';
import { computed, inject, nextTick, onActivated, onDeactivated, onMounted, ref, watch, } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { consumeSidebarDashboardReset, filtersFromQuery, peekSidebarDashboardReset, queryHasDashboardFilters, replaceDashboardQuery, resolveDashboardFilters, } from '@/helpers/dashboard-query';
import { getCompanyCode } from '@/helpers/get-company-code';
import httpClient from '@/httpClient';
const DASHBOARD_PATH = '/resourcing';
export default /*#__PURE__*/ _defineComponent({
    ...{
        name: 'ResourcingDashboard',
    },
    __name: 'ResourcingDashboard',
    setup(__props) {
        const BASE_FILTER_DEFAULTS = {
            stage: 'starter.notifyBudgetApprover',
            search: '',
            sort: 'Short ID',
            'sort-order': 'desc',
        };
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const atrs = ref([]);
        const loaded = ref(false);
        const isFirstActivation = ref(true);
        const isDashboardActive = ref(true);
        const suppressQueryWatch = ref(false);
        const stage = ref(BASE_FILTER_DEFAULTS.stage);
        const pageNumber = ref(0);
        const currentSort = ref(BASE_FILTER_DEFAULTS.sort);
        const sortOrder = ref('desc');
        const stats = ref([]);
        const searchTerm = ref('');
        const formatDate = inject('formatDate');
        const headings = [
            'Short ID',
            'Offers',
            'Taleo Reference Number',
            'Modified Date',
            'Job Title',
            'Company Code',
            'Hiring Manager',
            'First Line Approver',
            'Second Line Approver',
            'Resourcing Owner',
            'Doc Type',
        ];
        const routes = {
            STARTER: 'view-starter',
            LEAVER: 'view-leaver',
            AMEND: 'view-amend',
            OFFER: 'view-offer',
        };
        const stages = inject('stages', []);
        const sortables = {
            'Short ID': 'shortId',
            'Taleo Reference Number': 'taleo_vacancy_id',
            'Modified Date': 'modifiedDate',
            'Job Title': 'jobTitle',
            'Hiring Manager': 'hiringManager',
            'First Line Approver': 'firstLineApproval',
            'Second Line Approver': 'secondLineApproverEmail',
            'Resourcing Owner': 'recruitment_owner_email',
        };
        const documentsSorted = computed(() => {
            const sorted = [...atrs.value].sort((a, b) => {
                let val1;
                let val2;
                if (currentSort.value === 'Modified Date') {
                    val1 = a[sortables[currentSort.value]];
                    val2 = b[sortables[currentSort.value]];
                }
                else {
                    val1 = a[sortables[currentSort.value]]
                        ? a[sortables[currentSort.value]].toLowerCase()
                        : '-';
                    val2 = b[sortables[currentSort.value]]
                        ? b[sortables[currentSort.value]].toLowerCase()
                        : '-';
                }
                if (sortOrder.value === 'asc') {
                    if (val1 < val2)
                        return -1;
                    else if (val1 > val2)
                        return 1;
                    else
                        return 0;
                }
                else {
                    if (val1 < val2)
                        return 1;
                    else if (val1 > val2)
                        return -1;
                    else
                        return 0;
                }
            });
            return sorted;
        });
        const paginatedResults = computed(() => {
            const filteredBySearch = documentsSorted.value.filter((item) => {
                const keys = Object.keys(item);
                for (const key of keys) {
                    if (item[key]
                        ?.toString()
                        .toLowerCase()
                        .includes(searchTerm.value.toLowerCase())) {
                        return true;
                    }
                }
                return false;
            });
            setTotalPages(Math.ceil(filteredBySearch.length / 25));
            if (filteredBySearch.length <= 25)
                return filteredBySearch;
            else {
                const pageStart = pageNumber.value * 25;
                const pageEnd = pageNumber.value * 25 + 25;
                return filteredBySearch.slice(pageStart, pageEnd);
            }
        });
        const setTotalPages = (val) => {
            totalPages.value = val;
        };
        const totalPages = ref(0);
        const stageDropdownItems = computed(() => stages.filter((stage) => ![
            'starter.complete',
            'offer.complete',
            'leaver.complete',
            'amend.complete',
        ].includes(stage.stageName)));
        const getCancelledOffers = (index) => atrs.value[index]?.offersArray?.filter((offer) => offer.active === 'CANCELLED') || [];
        const profile = computed(() => store.getters.getProfile);
        const filterDefaults = () => ({
            ...BASE_FILTER_DEFAULTS,
            stage: profile.value.RESOURCING
                ? 'starter.notifyRecruitment'
                : BASE_FILTER_DEFAULTS.stage,
        });
        const currentFilters = () => ({
            stage: stage.value,
            search: searchTerm.value,
            sort: currentSort.value,
            'sort-order': sortOrder.value,
        });
        const applyFilters = async (filters) => {
            suppressQueryWatch.value = true;
            stage.value = filters.stage ?? filterDefaults().stage;
            searchTerm.value = filters.search ?? '';
            currentSort.value = filters.sort ?? BASE_FILTER_DEFAULTS.sort;
            sortOrder.value =
                filters['sort-order'] === 'asc' || filters['sort-order'] === 'desc'
                    ? filters['sort-order']
                    : 'desc';
            await nextTick();
            suppressQueryWatch.value = false;
        };
        const filtersMatch = (filters) => filters.stage === stage.value &&
            filters.search === searchTerm.value &&
            filters.sort === currentSort.value &&
            filters['sort-order'] === sortOrder.value;
        const syncFiltersToRoute = async () => {
            suppressQueryWatch.value = true;
            try {
                await replaceDashboardQuery(router, DASHBOARD_PATH, currentFilters(), filterDefaults(), route.query);
            }
            finally {
                await nextTick();
                suppressQueryWatch.value = false;
            }
        };
        const findCount = (stage) => {
            const stat = stats.value?.find((item) => item.stage === stage);
            return stat?.count ?? 0;
        };
        const totalCount = computed(() => stats.value.reduce((a, b) => a + (b.count || 0), 0));
        const handleHeadingClick = (headingName) => {
            if (headingName === currentSort.value) {
                if (sortOrder.value === 'desc') {
                    sortOrder.value = 'asc';
                }
                else {
                    sortOrder.value = 'desc';
                }
            }
            else {
                if (sortables[headingName]) {
                    currentSort.value = headingName;
                    sortOrder.value = 'desc';
                }
            }
        };
        const navigateToDocument = async (id, docOwner) => {
            // find document
            const document = atrs.value.find((atr) => atr.docId === id);
            if (document && document.currentStageName === 'starter.notifyRecruitment') {
                router.push({ path: `/recruitment-team/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRecruitmentUpdated') {
                router.push({ path: `/recruitment-update/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyRoleAdvertised') {
                router.push({ path: `/advert-raised/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'starter.notifyCVsCollected') {
                router.push({ path: `/ready-for-selection/${id}/${docOwner}` });
            }
            else if (document &&
                (document.currentStageName === 'starter.notifyCandidateSelected' ||
                    document.currentStageName === 'starter.complete')) {
                router.push({ path: `/selection-complete/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyMakeOffer') {
                router.push({ path: `/offer-hr/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyPrepOffer') {
                router.push({ path: `/confirm/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyTermsHaveChanged') {
                router.push({ path: `/amend-terms/${id}/${docOwner}` });
            }
            else if (document && document.currentStageName === 'offer.notifyH2RAdmin') {
                router.push({ path: `/assign-admin-owner/${id}/${docOwner}` });
            }
            else if (document &&
                document.currentStageName === 'offer.notifyOfferSent') {
                router.push({ path: `/sap-confirmation/${id}/${docOwner}` });
            }
            else if (document) {
                router.push({ path: `/${routes[document.docType]}/${id}/${docOwner}` });
            }
        };
        const fetchAtrs = async () => {
            if (stage.value === 'all') {
                fetchAllAtrs();
            }
            else {
                const response = await httpClient.post('/bff/resourcing-by-stage', {
                    requestedBy: profile.value.email,
                    stage: stage.value,
                });
                atrs.value = response.data.body?.Items ?? [];
            }
        };
        const fetchAllAtrs = async () => {
            atrs.value = [];
            for (const docType of ['STARTER', 'LEAVER', 'AMEND', 'OFFER']) {
                const response = await httpClient.post('/bff/resourcing-all', {
                    requestedBy: profile.value.email,
                    docType,
                });
                atrs.value = [...atrs.value, ...(response.data.body?.Items ?? [])];
            }
        };
        const getAllStats = async () => {
            const response = await httpClient.post('/bff/all-stats', {
                requestedBy: profile.value.email,
            });
            stats.value = response.data.body?.Items ?? [];
        };
        const nextPage = () => {
            if (pageNumber.value + 1 !== totalPages.value)
                pageNumber.value++;
        };
        const prevPage = () => {
            if (pageNumber.value !== 0)
                pageNumber.value--;
        };
        const applySidebarReset = async () => {
            if (!consumeSidebarDashboardReset(DASHBOARD_PATH)) {
                return false;
            }
            await applyFilters(filterDefaults());
            pageNumber.value = 0;
            store.dispatch('setIsLoading', true);
            await fetchAtrs();
            await getAllStats();
            store.dispatch('setIsLoading', false);
            return true;
        };
        onMounted(async () => {
            store.dispatch('setIsLoading', true);
            const defaults = filterDefaults();
            const { filters, source } = await resolveDashboardFilters(router, DASHBOARD_PATH, route.query, defaults);
            if (source === 'defaults') {
                await applyFilters(defaults);
            }
            else {
                await applyFilters(filters);
            }
            pageNumber.value = 0;
            await fetchAtrs();
            await getAllStats();
            store.dispatch('setIsLoading', false);
            loaded.value = true;
        });
        onActivated(async () => {
            isDashboardActive.value = true;
            if (isFirstActivation.value) {
                isFirstActivation.value = false;
                return;
            }
            if (route.path !== DASHBOARD_PATH) {
                return;
            }
            if (await applySidebarReset()) {
                return;
            }
            // Silent refetch: keep filters, sort, and page; refresh list data only.
            await fetchAtrs();
            await getAllStats();
        });
        onDeactivated(() => {
            isDashboardActive.value = false;
        });
        watch(stage, async () => {
            if (suppressQueryWatch.value) {
                return;
            }
            store.dispatch('setIsLoading', true);
            pageNumber.value = 0;
            await syncFiltersToRoute();
            await fetchAtrs();
            store.dispatch('setIsLoading', false);
        });
        watch(searchTerm, async () => {
            if (suppressQueryWatch.value) {
                return;
            }
            pageNumber.value = 0;
            await syncFiltersToRoute();
        });
        watch([currentSort, sortOrder], async () => {
            if (suppressQueryWatch.value) {
                return;
            }
            await syncFiltersToRoute();
        });
        watch(() => route.query, async () => {
            if (suppressQueryWatch.value || route.path !== DASHBOARD_PATH) {
                return;
            }
            if (!isDashboardActive.value) {
                return;
            }
            const defaults = filterDefaults();
            if (queryHasDashboardFilters(route.query, defaults)) {
                const fromUrl = filtersFromQuery(route.query, defaults);
                if (filtersMatch(fromUrl)) {
                    return;
                }
                await applyFilters(fromUrl);
                pageNumber.value = 0;
                store.dispatch('setIsLoading', true);
                await fetchAtrs();
                store.dispatch('setIsLoading', false);
                return;
            }
            if (peekSidebarDashboardReset(DASHBOARD_PATH) && (await applySidebarReset())) {
                return;
            }
        });
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                _createTextVNode(),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("input", {
                            id: "search-filter",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event)),
                            type: "text",
                            name: "search",
                            class: "w-full mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                        }, null, 512), [
                            [_vModelText, searchTerm.value]
                        ])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_6, [
                        _hoisted_7,
                        _createTextVNode(),
                        _withDirectives(_createElementVNode("select", {
                            id: "filter-stage-select",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((stage).value = $event)),
                            name: "filter-stage",
                            class: "w-full mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm:text-sm border-gray-300 rounded-md"
                        }, [
                            _createElementVNode("option", _hoisted_8, "All (" + _toDisplayString(totalCount.value) + ")", 1),
                            _createTextVNode(),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stageDropdownItems.value, (stageItem) => {
                                return (_openBlock(), _createElementBlock("option", {
                                    key: stageItem.stageName,
                                    value: stageItem.stageName
                                }, _toDisplayString(stageItem.displayName) + " (" + _toDisplayString(findCount(stageItem.stageName)) + ")", 9, _hoisted_9));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, stage.value]
                        ])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("table", _hoisted_14, [
                                    _createElementVNode("thead", _hoisted_15, [
                                        _createElementVNode("tr", null, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(headings, (heading) => {
                                                return _createElementVNode("th", {
                                                    key: heading,
                                                    scope: "col",
                                                    class: "py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 relative cursor-pointer",
                                                    onClick: ($event) => (handleHeadingClick(heading))
                                                }, [
                                                    _createTextVNode(_toDisplayString(heading) + " ", 1),
                                                    (currentSort.value === heading)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                            (sortOrder.value === 'desc')
                                                                ? (_openBlock(), _createBlock(_unref(ArrowSmDownIcon), {
                                                                    key: 0,
                                                                    class: "h-5 w-5 text-gray-600"
                                                                }))
                                                                : (_openBlock(), _createBlock(_unref(ArrowSmUpIcon), {
                                                                    key: 1,
                                                                    class: "h-5 w-5 text-gray-600"
                                                                }))
                                                        ]))
                                                        : _createCommentVNode("", true)
                                                ], 8, _hoisted_16);
                                            }), 64))
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    (atrs.value.length)
                                        ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedResults.value, (atr, index) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: atr.docId,
                                                    class: _normalizeClass(index % 2 === 0 ? undefined : 'bg-gray-50')
                                                }, [
                                                    _createElementVNode("td", {
                                                        class: "whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6 text-blue-600 hover:underline cursor-pointer",
                                                        onClick: ($event) => (navigateToDocument(atr.docId, atr.requestedBy))
                                                    }, _toDisplayString(atr.shortId), 9, _hoisted_19),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_20, [
                                                        (atr.offersArray && atr.offersArray.length)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(atr.offersArray, (offer) => {
                                                                    return (_openBlock(), _createElementBlock("span", {
                                                                        key: offer.offerId,
                                                                        class: "offer text-blue-600 hover:underline"
                                                                    }, [
                                                                        _createVNode(_component_router_link, {
                                                                            to: `/selection-complete/${atr.docId}/${atr.requestedBy}`
                                                                        }, {
                                                                            default: _withCtx(() => [
                                                                                _createTextVNode(_toDisplayString(offer.candidate), 1)
                                                                            ]),
                                                                            _: 2
                                                                        }, 1032, ["to"])
                                                                    ]));
                                                                }), 128)),
                                                                _createTextVNode("\n                      (" + _toDisplayString(`${atr.offersArray.length - getCancelledOffers(index).length || 0}/${atr.maxOffers}`) + ")\n                    ", 1)
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("span", _hoisted_22, " - "))
                                                    ]),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_23, _toDisplayString(atr.taleo_vacancy_id ? atr.taleo_vacancy_id : '-'), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_24, _toDisplayString(atr.modifiedDate ? _unref(formatDate)(atr.modifiedDate, 'YYYY-MM-DD') : '-'), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_25, _toDisplayString(atr.jobTitle ? atr.jobTitle : '-'), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_26, _toDisplayString(_unref(getCompanyCode)(atr)), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_27, _toDisplayString(atr.hiringManager ? atr.hiringManager : '-'), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_28, _toDisplayString(atr.firstLineApproval ? atr.firstLineApproval : '-'), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_29, _toDisplayString(atr.secondLineApproverEmail ? atr.secondLineApproverEmail : '-'), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_30, _toDisplayString(atr.recruitment_owner_email ? atr.recruitment_owner_email : '-'), 1),
                                                    _createTextVNode(),
                                                    _createElementVNode("td", _hoisted_31, _toDisplayString(atr.docType), 1)
                                                ], 2));
                                            }), 128))
                                        ]))
                                        : _createCommentVNode("", true)
                                ]),
                                _createTextVNode(),
                                (loaded.value && !atrs.value.length)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_32, " No Requests to show... "))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("button", {
                                disabled: pageNumber.value === 0,
                                class: "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                onClick: prevPage
                            }, "Prev", 8, _hoisted_34),
                            _createTextVNode(),
                            _createElementVNode("button", {
                                disabled: (pageNumber.value + 1 === totalPages.value),
                                class: "ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-green-700 bg-white hover:bg-gray-50 disabled:opacity-25 disabled:text-gray-600 disabled:cursor-not-allowed",
                                onClick: nextPage
                            }, "Next", 8, _hoisted_35)
                        ])
                    ])
                ])
            ]));
        };
    }
});
